import React from "react";
import PropTypes from "prop-types";

import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";
import CustomeButton from "../../../components/Button";

const AddFlagModal = ({
  show,
  onCancel,
  data,
  onChange,
  onConfirm,
  isLoading,
  flagComment,
  isRemoveFlag,
}) => {
  return (
    <div className="">
      <Dialog
        visible={show}
        style={{ width: "40vw" }}
        onHide={onCancel}
        className="add-flag-modal"
      >
        <div className="add-flag-modal-content">
          <p className="add-flag-modal-heading">
            {isRemoveFlag
              ? `Why are you removing the flag from the ”${data.name}” ?`
              : `Why are you flagging the "${data.name}" ?`}
          </p>

          {!flagComment && <i className="pi pi-pencil edit-icon" />}
          <InputTextarea
            id="flag_comment"
            name="flag_comment"
            value={flagComment}
            onChange={onChange}
            className={`input-field appearance-none outline-none w-full ${!flagComment ? "p-left" : ""}  `}
            rows={10}
            maxLength={255}
            placeholder={
              isRemoveFlag
                ? "Let your team know why this task doesn't need to be flagged anymore"
                : "Let your team know why this task has been flagged"
            }
          />
          <div className="flex justify-content-end gap-2 mt-2">
            <CustomeButton
              label="Cancel"
              variant="outlined"
              onClick={onCancel}
            />

            <CustomeButton
              label={!isLoading && (isRemoveFlag ? "Remove Flag" : "Add Flag")}
              variant="contained"
              onClick={() => onConfirm({ ...data, flag: !isRemoveFlag })}
              loading={isLoading}
              disabled={isLoading}
              className={`access-btn  ${!flagComment && "disable"}`}
            />
          </div>
        </div>
      </Dialog>
    </div>
  );
};
AddFlagModal.propTypes = {
  show: PropTypes.bool,
  onCancel: PropTypes.func,
  data: PropTypes.object,
  onChange: PropTypes.func,
  onConfirm: PropTypes.func,
  isLoading: PropTypes.bool,
  flagComment: PropTypes.string,
  isRemoveFlag: PropTypes.bool,
};

export default AddFlagModal;
